export const getPersonalizationTrackingData = ({
    isMobile,
    personalizedItems,
}: {
    personalizedItems:
        | {
              associationType: string | null | undefined;
              hasPersonalizedItem: boolean | null | undefined;
          }
        | null
        | undefined;
    isMobile?: boolean;
}): Record<string, string> => {
    let personalization = 'false';
    if (personalizedItems && personalizedItems.associationType !== null) {
        const { hasPersonalizedItem, associationType } = personalizedItems;
        personalization = `${hasPersonalizedItem ? 'yes' : 'no'} - ${associationType}`;
    }
    const trackingData: Record<string, string> = {
        isCondensed: 'N',
        personalization,
        ...(isMobile && { mobileAdaptive: 'adaptive' }),
    };

    return trackingData;
};
